import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { Observable, of as observableOf } from 'rxjs';
import { skipWhile, switchMap, first } from 'rxjs/operators';
import { InitializationStatusCodes } from 'portalServices';
import { appRouteConstants } from '../../../app.route.constants';
import { AppServices } from 'app/servicelayer/app-services';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard implements CanActivate
{
    constructor(
        private appServices: AppServices,
        private router: Router
    ) { }

    public get initializationService() { return this.appServices.initializationService; }
    public get authenticationService() { return this.appServices.authenticationService; }

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>
    {
        return this.initializationService.initState
            .pipe(
                skipWhile((s: any) =>
                    s !== InitializationStatusCodes.RUNNING &&
                    s !== InitializationStatusCodes.UNAUTHENTICATED),
                switchMap((s: any) =>
                {
                    if (s === InitializationStatusCodes.UNAUTHENTICATED)
                    {
                        this.router.navigate([`/${appRouteConstants.AUTH.LOGIN}`]);
                        return observableOf(false);
                    }
                    return observableOf(true);
                }),
                first()
            ) as Observable<boolean>;
    }
}
